<template><svg xmlns="http://www.w3.org/2000/svg" width="56" height="57" viewBox="0 0 56 57" fill="none">
        <path
            d="M11.6709 18.8408L25.6709 32.8408M9.33756 32.8408L23.3376 18.8408L28.0042 11.8408M4.6709 11.8408L32.6709 11.8408M16.3376 4.84082L18.6709 4.84082M51.3376 51.5075L39.6709 28.1742L28.0042 51.5075M32.6709 42.1741L46.6709 42.1741"
            stroke="url(#paint0_linear_1013_41943)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        <defs>
            <linearGradient id="paint0_linear_1013_41943" x1="6.60727" y1="9.94499" x2="49.7513" y2="13.0528"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#47D18C" />
                <stop offset="1" stop-color="#66A3FF" />
            </linearGradient>
        </defs>
    </svg></template>